const initialState = {
    loading: false,
    modal: -1,
    editModal: -1,
    rates: [],
    total: 0,
    delStatus: undefined
}

const rateReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_RATE":
            return {
                ...state,
                loading: true,
                modal: 1
            }
        case "ADD_RATE_SUCCESS":
            state.rates.unshift(action.rate)
            return { ...state, loading: false, modal: 0 }
        case "ADD_RATE_FAILED":
            return {
                ...state,
                loading: false,
                modal: 1
            }
        case "GET_RATES":
            return {
                ...state,
                rates: action.rates,
                total: action.total
            }
        case "UPDATE_RATE_SUCCESS":
            let newState = {...state}
            newState.rates.splice(action.index, 1, action.rate);
            return {
                ...state,
                loading: false,
                modal: 0
            }
        case "DELETE_RATE":
            return {
                ...state,
                delStatus: -1
            }
        case "DELETE_RATE_SUCCESS":
            let originState = {...state}
            originState.rates.splice(action.index, 1);
            return {
                ...state,
                delStatus: 1
            }
        case "DELETE_RATE_FAILED":
            return {
                ...state,
                delStatus: 0
            }
        default:
            return state
    }
}

export default rateReducer